import { NgModule } from "@angular/core";
// BFX
// SERVICES
import { BfxAuthService } from "./services/bfx-auth.service";
import { BfxRBACService } from "./services/bfx-rbac.service";
import { BfxUserProfileService } from "./services/bfx-user-profile.service";
import { BfxConfigService } from "../../shared/auth-services/system-config/bfx-config.service";
import { BfxSoundsService } from "./services/bfx-sounds.service";
import { BfxDashboardMenuService } from "./services/bfx-dashboard-menu.service";
import { BfxNewOrderMenuService } from "./services/bfx-neworder-menu.service";
import { BfxPanelHelperService } from "./services/bfx-panel-helper.service";
import { BfxPrimeService } from "./services/bfx-prime.service";
import { BfxMouseModifierKeyService } from "./services/bfx-mouse-modifier-key.service";
import { BfxAppStatusService } from "./services/bfx-app-status.service";
import { BfxDealDetailsService } from "../bfx-deal-details/services/bfx-deal-details.service";
import { BfxPopupNotificatonSettingsService } from "./services/bfx-popup-notifications-settings.service";
import { BfxAppNotificatonSettingsService } from "./services/bfx-app-notifications-settings.service";
import { BfxSystemMessageService } from "./services/bfx-system-message.service";
import { BfxDocumentMouseEnterService } from "./services/bfx-document-mouseenter.service";
import { BfxDocumentMouseLeaveService } from "./services/bfx-document-mouseleave.service";
import { BfxReconnectDialogService } from "./services/bfx-reconnect-dialog.service";
import { BFXLogoutWarningService } from "./services/bfx-logout-warnings.service";

// GUARDs
import { AuthGuard } from "./guards/auth-guard.service";
import { PrimeGuard } from "./guards/prime-guard.service";
import { ResetGuard } from "./guards/reset-guard.service";
import { BfxSaveProfileNotificationService } from "./services/bfx-save-profile-notification.service";
import { BfxPublicProfileService } from "./services/bfx-public-profile.service";
import { BfxAppAdminLauncherService } from "./services/bfx-app-admin-launcher.service";
import { BfxClipboardService } from "shared/helper-services/bfx-clipboard.service";
import { BfxErrorHandlingService } from "app/bfx-common/services/bfx-error-handling.service";
import { CommonModule } from "@angular/common";
import { BfxFillWarningService } from "./services/bfx-fill-warning.service";

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [
    BfxAuthService,
    BfxAppAdminLauncherService,
    BfxClipboardService,
    BfxConfigService,
    BfxPopupNotificatonSettingsService,
    BfxAppNotificatonSettingsService,
    BfxSoundsService,
    BfxDashboardMenuService,
    BfxDocumentMouseEnterService,
    BfxDocumentMouseLeaveService,
    BfxMouseModifierKeyService,
    BfxNewOrderMenuService,
    BfxPanelHelperService,
    BfxPrimeService,
    BfxRBACService,
    BfxUserProfileService,
    BfxDealDetailsService,
    BfxAppStatusService,
    BfxSystemMessageService,
    BfxReconnectDialogService,
    BFXLogoutWarningService,
    BfxSaveProfileNotificationService,
    BfxPublicProfileService,
    BfxErrorHandlingService,
    BfxFillWarningService,
    AuthGuard,
    PrimeGuard,
    ResetGuard,
  ],
  exports: [],
})
export class BfxCommonModule {}
